"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
let ActionCsv = class ActionCsv extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.url = window.location.href;
        this.segments = this.url.split('/');
        this.projectId = this.segments[this.segments.indexOf('project') + 1];
        this.trialsId = this.segments[this.segments.indexOf('trials') + 1];
        this.isCsvLoading = false;
    }
    async downloadCsv() {
        this.isCsvLoading = true;
        try {
            const url = `/results/api/project/${this.projectId}/becrop-score/trials/${this.trialsId}/download`;
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `becrop-score-${this.projectId}.csv`);
            document.body.appendChild(link);
            await new Promise((resolve) => {
                link.click();
                resolve();
            });
            document.body.removeChild(link);
            this.finishAction();
        }
        catch (error) {
            console.error('Error descargando el archivo:', error);
        }
        setTimeout(() => { this.isCsvLoading = false; }, 1000);
    }
    finishAction() {
        this.$emit('finishAction');
    }
    closeModalAction() {
        this.finishAction();
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ActionCsv.prototype, "project", void 0);
ActionCsv = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { Button: bmk_ui_framework_1.Button, Download: lucide_vue_next_1.Download, Csv: bmk_ui_framework_1.Csv, Modal: bmk_ui_framework_1.Modal }
    })
], ActionCsv);
exports.default = ActionCsv;
